import { FilterOutlined, PlusOutlined } from "@ant-design/icons";
import {
  DatePicker as AntdDatePicker,
  Card,
  Flex,
  Row,
  Space,
  Tabs
} from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";

import { Button, CardContainer } from "components/elements";
import { useSelector } from "react-redux";
import TabPane from "antd/es/tabs/TabPane";
import { useState } from "react";
import styles from "../styles/Attendance.module.css";

import AttendenceFilter from "features/attendance/components/AttendenceFilter";

const HolidayCalendar = ({
  pageType,
  holidayCalendarGroupId,
  getPage = () => { },
  onYearChange = () => { },
  handleOnPageChange = () => { },
  onEdit = () => { },
  handleOnCalendarChange = () => { },
  calendarTabs = () => { },
  getCalendarModal = () => { },
  onEmployeeEdit = () => { },
  onCalendarEdit = () => { },
  onChange = () => { },
  onSearch = () => { },
  onCancel = () => { },
  onHolidayEdit = () => { },
  onEmployeeCalendarEdit = () => { }
}) => {
  console.log("dsdf ", holidayCalendarGroupId);
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const MENU = [
    {
      label: t('holiday_calendar.label.holiday'),
      key: "holiday"
    },
    {
      label: t('holiday_calendar.label.employee'),
      key: "employee",
    }
  ]

  // const [activeKey, setActiveKey] = useState(calendarTabs[0]?.key);
  // const [items, setItems] = useState(calendarTabs);
  const [useFilter, setUseFilter] = useState(false);
  return (
    <>
      {getCalendarModal()}
      <Space className={styles.container} size={24} direction="vertical">
        <Card
          style={{
            backgroundColor: "white",
            width: "100%",
            boxShadow: '0px 4px 2px 0px rgba(0, 0, 0, 0.15)',
            borderRadius: "20px"
          }}
        >
          <Space direction="horizontal">
            <Tabs
              className={styles.calendar}
              type={roles.includes('CREATE_CONFIGURATION|ATTENDANCE_SETTING|HOLIDAY_CALENDAR') ? "editable-card" : "card"}
              onChange={handleOnCalendarChange}
              onEdit={onEdit}
              tabBarGutter={8}
              tabBarStyle={{
                height: '50px',
              }}
            >
              {calendarTabs().map(tab => (
                <TabPane tab={tab?.label} key={tab?.key} closable={false} />
              ))}
            </Tabs>
          </Space>

          <div width="100%" height="fit-content">

            <Row justify="space-between">
              <Space direction="horizontal" size={12}>
                <Tabs
                  className={styles.tabMenu}
                  defaultActiveKey="holiday"
                  type="card"
                  size="large"
                  tabBarGutter={8}
                  items={MENU.map((menuItem) => {
                    return {
                      label: menuItem.label,
                      key: menuItem.key,
                    };
                  })}
                  onChange={handleOnPageChange}
                />
              </Space>
              <Space direction="horizontal" size={12}>
                <>
                  {pageType === 'holiday' && (
                    <>
                      {/* <div>
                        <AntdDatePicker
                          defaultValue={dayjs()}
                          onChange={onYearChange}
                          picker="year"
                          disabledDate={(currentDate) =>
                            currentDate.isBefore(dayjs("2024-01-01")) ||
                            currentDate.isAfter(dayjs("2034-12-31"))
                          }
                        />
                      </div> */}
                      <Button type="default" onClick={() => setUseFilter(!useFilter)} style={{ padding: "8px 16px", height: "40px", borderRadius: "8px" }}>
                        <Flex align="center" justify="center" gap={8}>
                          <FilterIcon />
                          <span style={{ color: "#667085" }}>{t('common.filter')}</span>
                        </Flex>
                      </Button>
                      {
                        roles.includes('CREATE_CONFIGURATION|ATTENDANCE_SETTING|HOLIDAY_CALENDAR') && (<Button onClick={onHolidayEdit} style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}>
                          {t("holiday.label.add_holiday")} <PlusOutlined />
                        </Button>)
                      }

                    </>
                  )}
                  {pageType === 'employee' && (
                    <>
                      {/* <Button type="default" onClick={() => setUseFilter(!useFilter)}>
                        {t("common.filter")} <FilterOutlined />
                      </Button> */}
                      <Button onClick={onEmployeeEdit}>
                        {t("holiday.label.add_employee")} <PlusOutlined />
                      </Button>
                    </>
                  )}
                </>

              </Space>
            </Row>
            {useFilter &&
              // (
              //   getPage()
              // )
              <CardContainer width="100%" height="fit-content">
                <AttendenceFilter
                  onEdit={onEdit}
                  dataFlag={"holiday"}
                  onCancel={onCancel}
                  onChange={onChange}
                  onSubmit={onSearch} />
              </CardContainer>

            }
            {<CardContainer width="100%" height="fit-content">{getPage()}</CardContainer>}
          </div>
        </Card>


      </Space >
    </>
  );
};

export default HolidayCalendar;

{/* {useFilter && (
            <CardContainer width="100%" height="fit-content">
              <HolidayCalendarFilter
                isLoading={isLoading}
                pagination={pagination}
                dataSource={holidayList}
                onEdit={onEdit}
                dataFlag={"holiday"}
                onCancel={onCancel}
                onChange={onChange}
                onSubmit={onSearch}
              />
            </CardContainer>
          )} */}